import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FiMenu, FiX, FiTrendingUp, FiChevronDown } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { name: 'Home', path: '/' },
    { 
      name: 'Services', 
      path: '#',
      dropdown: [
        { name: 'Local SEO', path: '/services/local-seo' },
        { name: 'AI Optimization (AEO)', path: '/services/aeo' },
        { name: 'AI Voice & Automation', path: '/services/voice-automation' },
        { name: 'Revenue CRM', path: '/services/crm-system' },
        { name: 'Content Marketing', path: '/services/content-marketing' },
        { name: 'Web Design', path: '/services/web-design' },
      ]
    },
    { name: 'Results', path: '/case-studies' },
    { name: 'Pricing', path: '/pricing' },
    { name: 'Free Audit', path: '/audit', isCta: true },
  ];

  return (
    <nav className="fixed w-full z-50 bg-white/90 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          <Link to="/" className="flex items-center gap-2 font-bold text-2xl text-slate-900">
            <SafeIcon icon={FiTrendingUp} className="text-orange-600 text-3xl" />
            <span>AlbertaSEO</span>
          </Link>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              link.dropdown ? (
                <div key={link.name} className="relative group">
                  <button className="flex items-center gap-1 text-sm font-medium text-slate-600 hover:text-orange-600 py-4">
                    {link.name} <SafeIcon icon={FiChevronDown} className="text-xs" />
                  </button>
                  <div className="absolute top-full left-0 w-64 bg-white border border-gray-100 shadow-xl rounded-xl py-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all">
                    {link.dropdown.map(sub => (
                      <Link key={sub.path} to={sub.path} className="block px-4 py-2.5 text-sm text-slate-600 hover:bg-orange-50 hover:text-orange-600 transition-colors">
                        {sub.name}
                      </Link>
                    ))}
                  </div>
                </div>
              ) : (
                <Link 
                  key={link.name} 
                  to={link.path} 
                  className={`text-sm font-medium transition-colors ${
                    link.isCta 
                      ? 'px-5 py-2.5 bg-orange-600 text-white rounded-full hover:bg-orange-700 shadow-lg shadow-orange-600/20' 
                      : 'text-slate-600 hover:text-orange-600'
                  }`}
                >
                  {link.name}
                </Link>
              )
            ))}
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-slate-600 hover:text-slate-900 p-2">
              <SafeIcon icon={isOpen ? FiX : FiMenu} className="text-2xl" />
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Nav */}
      {isOpen && (
        <div className="md:hidden bg-white border-t border-gray-100 absolute w-full max-h-screen overflow-y-auto">
          <div className="px-4 pt-2 pb-6 space-y-2">
            {navLinks.map((link) => (
              <div key={link.name}>
                {link.dropdown ? (
                  <>
                    <button 
                      onClick={() => setServicesOpen(!servicesOpen)}
                      className="flex items-center justify-between w-full px-3 py-3 text-base font-medium text-slate-600"
                    >
                      {link.name} <SafeIcon icon={FiChevronDown} />
                    </button>
                    {servicesOpen && (
                      <div className="pl-6 space-y-2">
                        {link.dropdown.map(sub => (
                          <Link key={sub.path} to={sub.path} onClick={() => setIsOpen(false)} className="block py-2 text-sm text-slate-500">
                            {sub.name}
                          </Link>
                        ))}
                      </div>
                    )}
                  </>
                ) : (
                  <Link
                    to={link.path}
                    onClick={() => setIsOpen(false)}
                    className={`block px-3 py-3 rounded-md text-base font-medium ${
                      link.isCta ? 'bg-orange-600 text-white mt-4 text-center' : 'text-slate-600 hover:bg-slate-50'
                    }`}
                  >
                    {link.name}
                  </Link>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;